var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:['dashboard-content', { watermark: _vm.watermark }],attrs:{"elevation":"0"}},[_c('div',{staticClass:"dashboard-content-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }